import clsx from 'clsx';
import type * as React from 'react';

import { DataTestIds } from '@repo/frontend-shared';
import type { SDSTableAlign } from '@repo/sds/components/SDSTable/types/table.types';

interface SDSTableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
  align?: SDSTableAlign;
  ref?: React.Ref<HTMLTableCellElement>;
  'data-testid'?: string;
}

export function SDSTableCell({
  children,
  align = 'left',
  className,
  ref,
  'data-testid': dataTestIdFromProps,
  ...restProps
}: SDSTableCellProps) {
  const dataTestId =
    typeof dataTestIdFromProps === 'string' && dataTestIdFromProps.length > 0
      ? dataTestIdFromProps
      : DataTestIds.SDS.SDS_TABLE_CELL;

  return (
    <td
      ref={ref}
      className={clsx('SDSTableCell', `SDSTableCell--align-${align}`, className)}
      data-testid={dataTestId}
      {...restProps}
    >
      {children}
    </td>
  );
}
